import { Card, Grid, Heading } from '@veracity/vui'
import { Control } from 'react-hook-form'

import { SelectFormControl } from '@/components'
import { ScenarioDetailed } from '@/interfaces'
import { isPvScenario, isWindScenario } from '@/utils'

import { useScenarioLibrariesDictionaries } from '../../hooks'
import { ScenarioDetailsFormValues } from '../../types'

interface Props {
  scenarioInfo?: ScenarioDetailed
  formControl: Control<ScenarioDetailsFormValues>
  isFormDisabled: boolean
}

export const ScenarioDetailsContentDatasetsForm = ({
  scenarioInfo,
  formControl,
  isFormDisabled
}: Props) => {
  const {
    wholesaleMarket,
    lossFactors,
    incomeAdjustment,
    finances,
    productionProfilesWind,
    productionProfilesPv,
    otherBessInputs
  } = useScenarioLibrariesDictionaries()

  const isPvProductionProfilesVisible =
    !!scenarioInfo && isPvScenario(scenarioInfo.systemConfiguration)

  const isWindProductionProfilesVisible =
    !!scenarioInfo && isWindScenario(scenarioInfo.systemConfiguration)

  return (
    <Card column p={2} gap={2} h="100%">
      <Heading size="h4">Input Datasets</Heading>

      <Grid gap={2} gridTemplateColumns={{ xs: 2, md: 3, xl: 1, xxl: 2 }}>
        <SelectFormControl
          label="Wholesale Market"
          control={formControl}
          formControlName="wholesaleMarketPriceId"
          options={wholesaleMarket}
          disabled={isFormDisabled}
          maxHeight={200}
        />

        <SelectFormControl
          label="Finances"
          control={formControl}
          formControlName="finansesDatasetId"
          options={finances}
          disabled={isFormDisabled}
          maxHeight={200}
        />

        <SelectFormControl
          label="Income Adjustment"
          control={formControl}
          formControlName="incomeAdjustmentsId"
          options={incomeAdjustment}
          disabled={isFormDisabled || true /* TODO: Temporary disabled */}
          maxHeight={200}
        />

        <SelectFormControl
          label="Loss Factors"
          control={formControl}
          formControlName="lossFactorsId"
          options={lossFactors}
          disabled={isFormDisabled}
          maxHeight={200}
        />

        {isPvProductionProfilesVisible && (
          <SelectFormControl
            label="PV Production Profiles"
            control={formControl}
            formControlName="pvProductionProfileId"
            options={productionProfilesPv}
            disabled={isFormDisabled}
            maxHeight={200}
          />
        )}

        {isWindProductionProfilesVisible && (
          <SelectFormControl
            label="Wind Production Profiles"
            control={formControl}
            formControlName="windProductionProfileId"
            options={productionProfilesWind}
            disabled={isFormDisabled}
            maxHeight={200}
          />
        )}

        <SelectFormControl
          label="Other BESS Inputs"
          control={formControl}
          formControlName="otherBessInputId"
          options={otherBessInputs}
          disabled={isFormDisabled}
          maxHeight={200}
        />
      </Grid>
    </Card>
  )
}
